// extracted by mini-css-extract-plugin
export default {"facetSearchContainer":"facetSearchContainer---G8QCx","facetSearch":"facetSearch---w6rde","moreIcon":"moreIcon---OV7zJ"};